<script setup>
    defineProps({fill: String});
</script>
<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 7C14 7.4813 13.6533 7.875 13.2222 7.875H12.4443V13.125C12.4443 13.6082 12.096 14 11.6665 14H9.33343C8.90385 14 8.55565 13.6082 8.55565 13.125V10.0623C8.55565 9.82073 8.38158 9.62484 8.16681 9.62484H5.83362C5.61886 9.62484 5.44474 9.82073 5.44474 10.0623V13.125C5.44474 13.6082 5.09653 14 4.66696 14H2.33389C1.90434 14 1.55611 13.6082 1.55611 13.125V7.875H0.777778C0.345674 7.875 2.43056e-05 7.48007 0 7C0 6.75248 0.0933819 6.51066 0.265465 6.34118L6.48769 0.216617C6.65693 0.049875 6.85069 0 7 0C7.18285 0 7.36573 0.0722148 7.51231 0.216617L13.7345 6.34118C13.9066 6.51066 14 6.75248 14 7Z"
      :fill="fill ? fill : '#98A2B3'"
    />
  </svg>
</template>
